import apis from '@api/api';
import MyInputToolbar from '@navigation/screens/MidLevel/MessageScreen/Components/InputToolbar';
import CommentsFlatList from '@navigation/screens/MidLevel/WelcomeScreen/Widgets/Components/CommentsFlatList';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import { selectUser } from '@reduxLocal/selectors/userSelectors';
import React, { useEffect, useState } from 'react';
import { ScrollView, View } from 'react-native';

interface NotesHistoryProps {
  dataId: string;
  notesHistory?: any[];
}

const NotesHistory = ({dataId, notesHistory}: NotesHistoryProps) => {
  const [replyText, setReplyText] = useState('');
  const theme = themeSelector();
  const { avatar, _id, name, surname } = selectUser();
  const [notes, setNotes] = useState(notesHistory);
  const listRef = React.useRef<ScrollView>(null);

  useEffect(() => {
    setTimeout(() => {
      listRef.current?.scrollToEnd({ animated: true });
    }, 500);
  }, []);

  const _handlePost = async (message) => {
    await apis.postDataNote(dataId, message).then((res) => {
      console.log('posted note', res);
      setNotes([...notes, {
        _id: res,
        user: {
          _id: _id,
          profile_information: {
            name,
            surname,
            avatar: {
              img: avatar?.img
            }
          }
        },
        comment: message,
        createdAt: new Date()
      }]);
      if(listRef.current) listRef.current?.scrollToEnd?.({ animated: true });
    })
  }

  return (
    <View style={{ flex: 1, marginHorizontal: -30 }}>
      <View style={{ flex: 1, minHeight: "90%" }}>
        <CommentsFlatList ref={listRef} emptyPlaceHolder={"No notes just yet!"} comments={notes} feedId={dataId} removeCallback={undefined} />
      </View>
      <MyInputToolbar containerStyle={{ position: 'relative', minHeight: 70, minWidth: "101%", borderTopStartRadius: 0, borderBottomStartRadius: 0, left: -5, bottom: -10 }} user={{ _id: _id, avatar: avatar?.img }} staticPress personify messageGetter={replyText} removeAttach removeBorderRadius backgroundColor={theme ? '#ececec' : 'grey'} maxHeight={20} messageSetter={setReplyText} placeHolder={"Leave a note"} sendMessageCallback={(e) => _handlePost(e)} />
    </View>
  )
}
export default NotesHistory;